<div class="flex justify-between items-center bg-white px-[20px] py-[10px] border-b border-[#e0e0e0] shadow-[0_2px_4px_rgba(0,0,0,0.1)] h-[60px]">
  <div class="search-bar"></div>
  <div class="flex items-center gap-[20px]">
    <div class="relative inline-block">
      <span class="profile-icon flex items-center text-[#01405c]">
        {{ userName }}
        <i class="ml-4 pi pi-user text-black"></i>
      </span>
    </div>
    <button
      class="hover:cursor-pointer group"
      [attr.aria-label]="'dashboard.navbar.logout' | translate"
      (click)="logout()"
    >
      <i
        id="logout-icon"
        class="pi pi-sign-out text-grey-900 text-lg p-3 rounded-full bg-white group-hover:bg-[#35335d] group-hover:text-white"
      ></i>
    </button>
  </div>
</div>